import { SimpleLogoPageContainer } from '@/components/shared/SimpleLogoPageContainer'
import { Stack, Text } from '@/components/ui'

export const ForbiddenPage = () => {
  return (
    <SimpleLogoPageContainer centered showVersion={false}>
      <Stack align="center" color="blue.600" fontWeight="semibold" gap="4">
        <Text fontSize="70px" lineHeight="1">
          403
        </Text>
        <Text>アクセスが制限されています</Text>
      </Stack>
    </SimpleLogoPageContainer>
  )
}
